export default {
  SET_TEXTS: (state, payload) => {
    state.texts = payload;
  },

  SET_HOME_TEXT: (state, payload) => {
    state.homeText = payload;
  },
};
